import React, { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, V1 } from "@/lib/api";
import { toast } from "sonner";

export default function ParentInvitations() {
  const [items, setItems] = useState([]);

  const load = () => api.get(`${V1}/invitations/mine`).then((r) => setItems(r.data || []));
  useEffect(() => { load(); }, []);

  const respond = async (id, status) => {
    try {
      await api.patch(`${V1}/invitations/${id}`, { status });
      toast.success("Cevabınız iletildi");
      load();
    } catch (e) { toast.error("Güncellenemedi"); }
  };

  return (
    <div className="space-y-6" data-testid="parent-invitations-page">
      <div>
        <div className="overline text-accent">Davetler & Teklifler</div>
        <h1 className="font-display text-3xl font-bold tracking-tight">Okul Davetleri</h1>
        <p className="text-muted-foreground mt-2">Başarılı katılımlarınıza karşılık okullardan gelen burs teklifleri.</p>
      </div>
      <div className="grid gap-4">
        {items.length === 0 && (
          <div className="p-10 rounded-xl border border-dashed border-border text-center">
            <Mail className="h-8 w-8 mx-auto text-muted-foreground mb-2" />
            <div className="text-muted-foreground">Henüz davet yok. Deneme sınavlarına düzenli katılım ve yüksek performans şansınızı artırır.</div>
          </div>
        )}
        {items.map((i) => (
          <div key={i.id} className="p-6 rounded-xl border border-border bg-card" data-testid={`inv-${i.id}`}>
            <div className="flex flex-wrap justify-between gap-4">
              <div>
                <div className="text-xs text-muted-foreground">{i.school?.province} / {i.school?.district}</div>
                <div className="font-display font-bold text-lg">{i.school?.name}</div>
                <div className="text-sm mt-2">{i.child?.name} {i.child?.surname}</div>
                <div className="mt-2 inline-block px-3 py-1 rounded bg-accent/10 text-accent text-sm font-bold">
                  %{i.scholarship_rate} · {i.scholarship_type}
                </div>
                {i.message && <div className="mt-3 text-sm bg-muted p-3 rounded">{i.message}</div>}
              </div>
              <div className="flex flex-col gap-2 min-w-[160px]">
                <span className="text-xs px-2 py-0.5 bg-muted rounded uppercase tracking-widest">{i.status}</span>
                {i.status === "sent" && (
                  <>
                    <Button size="sm" onClick={() => respond(i.id, "accepted")} data-testid={`accept-${i.id}`}>Kabul Et</Button>
                    <Button size="sm" variant="outline" onClick={() => respond(i.id, "contact_requested")} data-testid={`contact-${i.id}`}>İletişim İste</Button>
                    <Button size="sm" variant="ghost" onClick={() => respond(i.id, "rejected")} data-testid={`reject-${i.id}`}>Reddet</Button>
                  </>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
